<div style="display:flex;flex-flow:column">
  <div *ngIf="showTimezone">
    <app-timezone-picker [guess]="true" [timezone]="schedule?.timezone" (timezoneChange)="timezoneChanged($event)"></app-timezone-picker>
  </div>
  <div style="display:flex;flex-flow:row">
    <div style="margin-right:5px" [formGroup]="formGroup">
      <mat-button-toggle-group formControlName="interval" (change)="computeForTab()">
        <mat-button-toggle value="once">Once</mat-button-toggle>
        <mat-button-toggle value="daily">Daily</mat-button-toggle>
        <mat-button-toggle value="weekly">Weekly</mat-button-toggle>
        <mat-button-toggle value="monthly">Monthly</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div style="margin-right:5px">
      <mat-form-field appearance="outline" style="width:280px">
        <mat-label>Enter a date/time range</mat-label>
        <app-datetime-range-input [formGroup]="timings" [rangePicker]="picker">
          <input appStartDatetime formControlName="start" placeholder="Start date">
          <input appEndDatetime formControlName="end" placeholder="End date">
        </app-datetime-range-input>
        <app-datetime-picker-toggle matIconSuffix [for]="picker"></app-datetime-picker-toggle>
        <app-datetime-range-picker #picker></app-datetime-range-picker>

        @if (timings.controls.start.hasError('matStartDateInvalid')) {
        <mat-error>Invalid start date/time</mat-error>
        }
        @if (timings.controls.end.hasError('matEndDateInvalid')) {
        <mat-error>Invalid end date/time</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div style="display:flex;flex-flow:column;margin:0 0;">
    <div *ngIf="getInterval() == 'once'">
      &nbsp;
    </div>
    <div *ngIf="getInterval() == 'daily'" [formGroup]="dailyForm">
      <div style="margin-left:16px">
        Recur Every&nbsp;
        <mat-form-field appearance="outline"
                        class="schdlr-dly-day-selector">
          <mat-label>Day(s)</mat-label>
          <input matInput type="number" formControlName="days" />
        </mat-form-field>
        &nbsp;days
      </div>
    </div>
    <div *ngIf="getInterval() == 'weekly'" [formGroup]="weeklyForm">
      <div style="margin-left:16px">
        Recur Every&nbsp;
        <mat-form-field appearance="outline"
                        class="schdlr-dly-day-selector">
          <mat-label>Week(s)</mat-label>
          <input matInput type="number" formControlName="weeks"/>
        </mat-form-field>
        &nbsp;weeks on:
      </div>
      <div style="margin-left:9px">
        <mat-checkbox *ngFor="let day of selectOptions.days; let i = index" class="checkbox-margin" [formControlName]="day">
          <span class="schdlr-wkly-every-span">{{selectOptions.dayNames[i]}}</span>
        </mat-checkbox>
      </div>
    </div>
    <div *ngIf="getInterval() == 'monthly'" [formGroup]="monthlyForm">
      <div style="display:flex;flex-flow:row;align-items:center">
        <div style="margin-left:12px;width:79px">
          Months:
        </div>
        <div>
          <mat-form-field appearance="outline" style="width:400px">
            <mat-label>Months</mat-label>
            <mat-select formControlName="months" #statuses multiple>
              <mat-option *ngFor="let month of selectOptions.months; let i = index"
                          [value]="month">
                {{selectOptions.monthNames[i]}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <mat-radio-group formControlName="subTab">
        <div>
          <mat-radio-button name="monthly-radio" value="specificDays">
            <div formGroupName="specificDays" style="display:flex;flex-flow:row;align-items:center">
              <div style="width:50px">
                Days:&nbsp;
              </div>
              <div>
                  <mat-form-field appearance="outline" style="width:300px">
                    <mat-label>Days</mat-label>
                    <mat-select class="month-days" formControlName="days" multiple>
                      <mat-option *ngFor="let monthDaysWithLast of options.cronFlavor == 'quartz' ? selectOptions.monthDaysWithLasts : selectOptions.monthDaysWithOutLasts"
                                  [value]="monthDaysWithLast">
                        {{monthDayDisplay(monthDaysWithLast)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
              </div>
            </div>
          </mat-radio-button>
        </div>
        <div>
          <mat-radio-button name="monthly-radio" value="specificDaysOfWeek">
            <div formGroupName="specificDaysOfWeek" style="display:flex;flex-flow:row;align-items:center">
              <div style="width:50px">
                On:
              </div>
              <div>
                <mat-form-field appearance="outline" style="width:300px">
                  <mat-label>Week</mat-label>
                  <mat-select class="day-order-in-month" formControlName="on">
                    <mat-option *ngFor="let monthWeek of selectOptions.monthWeeks; let i = index"
                                [value]="monthWeek">
                      {{selectOptions.monthWeeksNames[i]}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                &nbsp;
                <mat-form-field appearance="outline" style="width:300px">
                  <mat-label>Days</mat-label>
                  <mat-select class="week-days" formControlName="weekDays">
                    <mat-option *ngFor="let day of selectOptions.days; let i = index"
                                [value]="day">
                      {{selectOptions.dayNames[i]}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </div>
    <div>
      <mat-divider></mat-divider>
    </div>
    <div class="margin-10" [formGroup]="advancedForm">
      <div style="display:flex;flex-flow:row;align-items:center;">
        <div>
          <mat-checkbox class="checkbox-margin" formControlName="repeatSelected">
            <span>Repeat every&nbsp;</span>
          </mat-checkbox>
          <app-basic-time-picker #repeatTimePicker formGroupName="repeat" label="Repeat"></app-basic-time-picker>
        </div>
        <div>
          &nbsp;for a duration of&nbsp;
        </div>
        <div>
          <app-basic-time-picker #durationTimePicker formGroupName="duration" label="Duration"></app-basic-time-picker>
        </div>
      </div>
      <div style="display:flex;flex-flow:row;align-items:center;">
        <div style="width:108px">
          <mat-checkbox class="checkbox-margin" formControlName="startingSelected">
            <span>Starting at&nbsp;</span>
          </mat-checkbox>
        </div>
        <div formGroupName="starting">
          <mat-form-field appearance="outline" class="schdlr-dly-time-picker">
            <input matInput [ngxTimepicker]="startPicker" [format]="24" formControlName="at">
            <ngx-material-timepicker #startPicker></ngx-material-timepicker>
          </mat-form-field>
        </div>
      </div>
    <div style="margin: 0 10px">
      Starting {{start | date:'short': '' : translate.currentLang }}, {{ cronBasicDescription }} until {{end | date:'short': '' : translate.currentLang }}<br />
      (Based on: {{start | date:'short': '' : translate.currentLang }} - {{end | date:'short': '' : translate.currentLang }} {{ cronDescription }})<br/>
      [{{checkCron()}}]
    </div>
    <div *ngIf="getNextTimes(10) > 0" style="margin: 0 10px;">
      <div><strong>Here are the first few times the schedule will trigger:</strong></div>
      <span *ngFor="let time of times; let i = index">{{showDate(i) ? (time | date:'shortDate': '' : translate.currentLang) : ''}} {{time | date:'shortTime'}}{{i + 1 < times.length ? ', ' : ''}}</span>
    </div>
  </div>
 </div>
